import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'mapfre-auditlib-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor() { }

  @Input() visible;
  @Output() visibleChange = new EventEmitter();

  ngOnInit() {

  }

  onChange(event) {
    this.visible = event;
    this.visibleChange.emit(event);
  }

}
